<template>
  <div :class="$style.layout">
    <main v-if="!items.length">
      <h2 class="title-strat">
        {{ noResultText }}
      </h2>
    </main>
    <main
      v-else
      :class="$style.container"
    >
      <div
        v-for="item in items"
        :key="item.route"
        :class="$style.item"
      >
        <Card
          flexible
          :card="item"
          class="h-100"
        />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    items: Record<string, any>[]
    noResultText?: string
  }>(),
  {
    noResultText: 'Aucun contenu',
  },
)
</script>

<style scoped>
.h-100 {
  height: 100% !important;
}
</style>

<style lang="scss" module>
.layout {
  padding: 0 2.5rem;

  @media (min-width: 700px) {
    max-width: 200rem;
    margin: 0 auto;
    padding: 0 8rem;
  }
}

.container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
}

.item {
  flex-basis: 100%;
  margin-bottom: 2rem;
  padding: 0 1rem;

  @media (min-width: 600px) {
    flex-basis: 50%;
  }

  @media (min-width: 992px) {
    flex-basis: calc(100% / 3);
  }

  @media (min-width: 1600px) {
    flex-basis: 25%;
  }
}
</style>
